/* eslint-disable @next/next/no-img-element */
// @ts-nocheck

import React, { useEffect, useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { EffectCoverflow, Navigation } from "swiper";
import { noop } from "lodash";
import { useRouter } from "next/navigation";

import { Flex, RATypography } from "@/components/customs";
import { SEChevronLeft, SEChevronRight, SEClock, SESpeedometer, SEUserGroup } from "@/components/svgs";
import { AircraftOwnershipTag } from "@/components/molecules";
import s from "./AircraftDropdownTablet.module.css";
import { ButtonV2 } from "@/components/customs/ButtonV2";
import { PATH_ROUTES } from "@/config/routes";
import { AIRCRAFT_PROVIDER } from "@/config/constants";

export const AircraftDropdownTablet = ({ selectedCategory, onSetSelectedCategory = noop }: any) => {
	const router = useRouter();
	const swiperRef = useRef(null);

	const [activeIndex, setActiveIndex] = useState(0);

	const aircraftTypeLength = selectedCategory?.aircraft_type_list?.length ?? 0;
	const aircraftType = selectedCategory?.aircraft_type_list?.[activeIndex] ?? null;
	const isPartner = aircraftType?.aircraft_provider === AIRCRAFT_PROVIDER.PARTNER;

	useEffect(() => {
		if (swiperRef.current) {
			swiperRef.current.slideTo(activeIndex);
		}
	}, [activeIndex]);

	return (
		<div className={s.container}>
			<div className={s.content}>
				<button
					className={s.swiper_button_prev}
					style={{
						visibility: aircraftTypeLength > 1 ? "visible" : "hidden",
					}}
				>
					<SEChevronLeft />
				</button>
				<button
					className={s.swiper_button_next}
					style={{
						visibility: aircraftTypeLength > 1 ? "visible" : "hidden",
					}}
				>
					<SEChevronRight />
				</button>
				<Swiper
					effect={"coverflow"}
					grabCursor={true}
					centeredSlides={true}
					slidesPerView={3}
					slidesPerGroup={1}
					coverflowEffect={{
						slideShadows: false,
						rotate: 0,
						stretch: -160,
						depth: 100,
						scale: 1,
					}}
					modules={[EffectCoverflow, Navigation]}
					navigation={{
						prevEl: `.${s.swiper_button_prev}`,
						nextEl: `.${s.swiper_button_next}`,
					}}
					onSwiper={(w) => {
						swiperRef.current = w;
					}}
					onSlideChange={(w) => setActiveIndex(w.activeIndex)}
					onBeforeDestroy={() => {
						swiperRef.current = null;
					}}
					style={{ height: "calc(100% - 44px)" }}
				>
					{selectedCategory?.aircraft_type_list?.map((item: any) => {
						const mainImage =
							item.images?.find((e) => e.type === "MAIN")?.url ??
							item.images?.[0]?.url ??
							"/images/example/aircraft_light_turbo.png";

						return (
							<SwiperSlide key={item._id} className={s.explore_fleet_swiper_slide}>
								<Flex
									alignItems="center"
									gap={12}
									style={{
										height: "100%",
									}}
								>
									<div
										style={{
											width: "100%",
										}}
									>
										<Flex
											alignItems="center"
											gap={8}
											justifyContent="space-between"
											className={s.explore_fleet_swiper_slide_header}
										>
											<Flex alignItems="center" gap={8}>
												<AircraftOwnershipTag isPartner={isPartner} />
												<RATypography variant="sub-heading3">{item.name}</RATypography>
											</Flex>
											{!isPartner && (
												<ButtonV2
													width={100}
													size="small"
													color="#222222"
													onClick={() => {
														router.push(`${PATH_ROUTES.PATH_AIRCRAFT_TYPES}/${item.slug}`);
													}}
												>
													Details
												</ButtonV2>
											)}
										</Flex>
										<div
											style={{
												position: "relative",
												marginBlock: "32px 24px",
											}}
										>
											<img
												width="100%"
												src={mainImage}
												alt={item.name}
												style={{
													objectFit: "contain",
													objectPosition: "center",
												}}
											/>
											<div className={s.explore_fleet_swiper_slide_name_overlay}>
												<RATypography variant="sub-heading3" align="center">
													{item.name}
												</RATypography>
											</div>
										</div>
										<Flex
											gap={12}
											alignItems="center"
											justifyContent="center"
											className={s.explore_fleet_swiper_slide_info}
										>
											<Flex gap={16}>
												<SEUserGroup />
												<div
													style={{
														width: 100,
													}}
												>
													<RATypography variant="gilda1">
														{item.properties?.max_pax ?? 0}
														{item.properties?.max_pax_symbol ?? ""}
													</RATypography>
													<RATypography variant="dm_sans1" top={2}>
														Passengers
													</RATypography>
												</div>
											</Flex>
											<Flex gap={16}>
												<SEClock />
												<div
													style={{
														width: 100,
													}}
												>
													<RATypography variant="gilda1">
														{item.properties?.max_fly_time ?? 0}
														{item.properties?.max_fly_time_symbol ?? ""}{" "}
														{item.properties?.max_fly_time_unit}
													</RATypography>
													<RATypography variant="dm_sans1" top={2}>
														Range
													</RATypography>
												</div>
											</Flex>
											<Flex gap={16}>
												<SESpeedometer />
												<div
													style={{
														width: 100,
													}}
												>
													<RATypography variant="gilda1">
														{item.properties?.cruising_speed ?? 0}
														{item.properties?.cruising_speed_symbol ?? ""}{" "}
														{item.properties?.cruising_speed_unit}
													</RATypography>
													<RATypography variant="dm_sans1" top={2}>
														Cruise Speed
													</RATypography>
												</div>
											</Flex>
										</Flex>
									</div>
								</Flex>
							</SwiperSlide>
						);
					})}
				</Swiper>
				<Flex alignItems="center" justifyContent="center">
					<button
						className={s.button_back}
						onClick={() => {
							onSetSelectedCategory(null);
							setActiveIndex(0);
						}}
					>
						<RATypography
							variant="sub-heading5"
							style={{
								letterSpacing: "2px",
							}}
						>
							BACK
						</RATypography>
					</button>
				</Flex>
			</div>
		</div>
	);
};
